export const GpsFlagIcon = ({
  width = '16',
  className = '',
  height = '16',
  viewBox = '0 0 16 16',
  fill = '#0B8E50',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
  >
    <path
      // eslint-disable-next-line max-len
      d="M3.8335 0.666656C4.10964 0.666656 4.3335 0.890517 4.3335 1.16666V2.39999L5.48061 2.17057C6.58096 1.9505 7.72156 2.05522 8.76343 2.47197L8.89923 2.52628C9.93996 2.94258 11.0855 3.02033 12.173 2.74846C12.6778 2.62225 13.1668 3.00408 13.1668 3.52445V8.43579C13.1668 8.86532 12.8745 9.23973 12.4578 9.34392L12.3148 9.37966C11.1351 9.67459 9.8925 9.59026 8.76343 9.13866C7.72156 8.72186 6.58096 8.61719 5.48061 8.83726L4.3335 9.06666V14.5C4.3335 14.7761 4.10964 15 3.8335 15C3.55736 15 3.3335 14.7761 3.3335 14.5V1.16666C3.3335 0.890517 3.55736 0.666656 3.8335 0.666656Z"
      fill={fill}
    />
  </svg>
)
